import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { TransferRoutingModule } from './transfer-routing.module';

@NgModule({
  declarations: [],
  imports: [CommonModule, TransferRoutingModule],
})
export class TransferModule {}
